/** A number of rows, and whether it is exact: an xlsx or CSV table's
 * count can overshoot. */
export interface RowCount {
  rows: number;
  exact: boolean;
}

/** A row count as the page shows it, "≈ 356" when it is approximate. */
export function rowCountText(count: RowCount): string {
  return count.exact ? String(count.rows) : `≈ ${count.rows}`;
}

/** How many of a list to show after one more "show more" step. */
export function showMore(shown: number, step: number, total: number): number {
  return Math.min(shown + step, total);
}
